<template>
    <section id="default-page">
        <div class="container full-width">
            <div class="row">
                <div class="col-md-12">
                    <h2>
                        Send Recommends
                    </h2>
                    <div class="row send-list-select-date">
                        <div class="col-md-4 col-sm-12">
                            <select name="auction_date" id="auction_date" @change="getFavList()"
                                    v-model="auctionDate">
                                <option v-for="date in dates"
                                        :value="date.value">{{ date.label }}
                                </option>
                            </select>
                        </div>
                        <div class="col-md-4">
                            <b-alert :show="dismissCountDown" variant="success" v-show="showSuccess">Email sent
                                successfully.
                            </b-alert>
                            <messages :messages="messages"/>
                        </div>
                    </div>
                    <div v-if="total > 0">
                        <div v-if="userListActive">
                            <a class="link back" @click="changeUserList">back to list</a>
                        </div>
                        <strong>Showing</strong>
                        <span>{{ from }}</span>-<span>{{ to }}</span> of <span>{{ total }}</span>
                        results
                    </div>
                    <div class="row">

                    <div v-bind:class="userListActive ? 'col-md-6 tag-list-container mobile-hide' : 'col-md-12 mobile-show'">
                        <b-table
                                class="list-table favourite-list-table"
                                :fields="fields"
                                :items="favourites"
                                ref="favouritesTable"
                                show-empty
                                selectable
                                select-mode="single"
                                @row-selected="onRowSelected"
                                @row-clicked="onRowClicked"
                        >
                            <template v-slot:empty="scope">
                                You have no favourite list...
                            </template>
                            <template v-slot:cell(last_sent)="data">
                                <template v-if="data.item.recommends && data.item.recommends.length">
                                    {{dateToMoment(data.item.recommends[0].created_at)}}
                                </template>
                            </template>
                            <template v-slot:cell(name)="data" @click="showMobile">
                                <div class="d-flex d-xl-inline-block align-items-center justify-content-between">
                                    <span class="name">{{data.item.name}}</span>
                                    <span class="counter">
                                    <template v-if="data.item.id === 0">
                                        ({{all_favourites_count}})
                                    </template>
                                    <template v-else>
                                        ({{data.item.vehicles_count}})
                                    </template>
                                </span>
                                </div>
                            </template>
                        </b-table>
                        <div class="row">
                            <div class="col-md-12" v-show="createList">
                                <a @click="addToList()" class="create-list">Create List <i
                                        class="fa fa-plus-circle"></i></a>
                            </div>
                            <div class="col-sm-12 col-md-4" v-show="listBox">
                                <input type="text" name="listName" id="listName" class="w-100" v-model="listName"
                                       v-on:keydown="storeList($event)"/>
                            </div>
                        </div>
                    </div>
                    <div :class="this.userListActive ? 'col-md-6 user-list-container mobile-show' : 'mobile-hide col-md-6 user-list-container'  " v-if="userListActive">
                        <b-table
                                class="list-table favourite-list-user-table"
                                :fields="user_fields"
                                :items="currentUsers"
                                show-empty
                        >
                            <template v-slot:empty="scope">
                                No members are added to list...
                            </template>
                            <template v-slot:head(sendEmail)="scope">
                                <span class="checkbox">
                                    <input id="send_mail_all" type="checkbox" v-model="sendMailAll" @change="onSendMailAll">
                                    <label for="send_mail_all"></label>
                                </span>
                                Send Email
                            </template>
                            <template v-slot:head(notify)="scope">
                                <span class="checkbox">
                                    <input id="notify_all" type="checkbox" v-model="notifyAll" @change="onNotifyAll">
                                    <label for="notify_all"></label>
                                </span>
                                Notify
                            </template>
                            <template v-slot:head(recommend)="scope">
                                <span class="checkbox">
                                    <input id="recommend_all" type="checkbox" v-model="recommendAll" @change="onRecommendAll">
                                    <label for="recommend_all"></label>
                                </span>
                                Recommend
                            </template>
                            <template v-slot:cell(name)="data">
                                <span :class="data.item.add_once ? 'add-once' : ''" :title="data.item.add_once ? 'Not saved to list.' : ''">
                                    {{data.item.name}}
                                <template v-if="data.item.company">
                                    ({{data.item.company.name}})
                                </template>
                                </span>
                                <span class="remove-member" :id="`removeuser-${data.item.id}`">
                                    <icon icon=" fa-minus-circle"></icon></span>
                                <b-popover :ref="`removeuser-${data.item.id}`" :target="`removeuser-${data.item.id}`" triggers="click">
                                    <div class="my-list-popover">
                                        Are you sure you want to remove this member from the list?
                                        <br/>
                                        <a @click="removeMember(data.item.id)" class="yes">Yes</a>
                                        <a @click="closeToolTip(`removeuser-${data.item.id}`)" class="no">No</a>
                                    </div>
                                </b-popover>
                            </template>
                            <template v-slot:cell(sendEmail)="data">
                                <span class="checkbox">
                                    <input type="checkbox" :id="'send_email-'+data.item.id" :value="data.item.id"
                                           v-model="sendMail">
                                    <label :for="'send_email-'+data.item.id"></label>
                                </span>
                            </template>
                            <template v-slot:cell(notify)="data">
                                <span class="checkbox" v-if="recommend.includes(data.item.id)">
                                    <input type="checkbox" :id="'notify-'+data.item.id" :value="data.item.id" v-model="notify">
                                    <label :for="'notify-'+data.item.id"></label>
                                </span>
                            </template>
                            <template v-slot:cell(recommend)="data">
                                    <span class="checkbox">
                                        <input type="checkbox" :id="'recommend-'+data.item.id" :value="data.item.id"
                                               v-model="recommend">
                                        <label :for="'recommend-'+data.item.id"></label>
                                    </span>
                            </template>

                        </b-table>
                        <div class="row" style="padding: 0px 15px;">
                            <div class="col-md-12 member">
                                <div class="row">
                                    <div class="col-md-12 list-actions">
                                        <a v-if="addUserButton" @click.prevent="addMember()" class="add-button link"
                                           href="#!">
                                            Add Member
                                            <icon icon=" fa-plus-circle"></icon>
                                        </a>
                                        <a v-if="sendListButton" @click.prevent="sendList()" class="link pull-right"
                                           href="#!">
                                            Send List
                                            <icon icon=" fa-paper-plane"></icon>
                                        </a>
                                        <a id="confirmDeleteList"
                                           @click.prevent="confirmDeleteList = !confirmDeleteList"
                                           class="link text-danger pull-right" href="#!">
                                            Delete List
                                            <icon icon=" fa-trash"></icon>
                                        </a>
                                        <a class="link pull-right"
                                           :href="$laravelRoute('favourites.index', {tag_id:tagId})">
                                            View Vehicles
                                            <icon icon=" fa-eye"></icon>
                                        </a>
                                        <b-popover :show.sync="confirmDeleteList"
                                                   target="confirmDeleteList" triggers="click">
                                            <div class="my-list-popover">
                                                This will delete the list along with it's members and vehicles. Are you
                                                sure?
                                                <br/>
                                                <a @click="deleteList" class="yes">Yes</a>
                                                <a @click="confirmDeleteList = false" class="no">No</a>
                                            </div>
                                        </b-popover>
                                    </div>
                                </div>
                                <div class="row" v-if="addUser">
                                    <div class="col-lg-6 col-md-12 input-area mb-3">
                                        <input ref="user_search_input" type="text" name="userName"
                                               placeholder="Start typing to search"
                                               v-on:keyup="getUsers()" id="userName" v-model="userName"
                                               class="textbox w-100"/>
                                    </div>
                                    <div class="col-lg-6 col-md-12 d-flex align-items-center">
                                        <span class="checkbox">
                                            <input type="checkbox" name="sales_rep" id="sales-rep" v-model="salesRep" @input="getUsers()"/>
                                            <label for="sales-rep">Filter by Sales Rep</label>
                                        </span>
                                    </div>
                                </div>
                                <div class="row user-detail" v-if="getUserList">
                                    <div class="col-md-12" v-for="user in getUserList">
                                        <div class="row detail">
                                            <div class="col-md-6">
                                                <span class="member-name">{{user.name}}</span>
                                                <span v-if="user.company">({{user.company.name}})</span>
                                            </div>
                                            <div class="col-md-6 link">
                                                <template v-if="selectedRow">
                                                    <a @click="saveToList(user.id)" class="save-list">Save to list</a> |
                                                    <a class="add-once" @click="addOnce(user.id, user.name, user.company)">
                                                        Add once
                                                    </a>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">&nbsp;</div>
                </div>
            </div>
        </div>
        </div>
    </section>
</template>
<script>
    import {mapState, mapActions} from 'vuex'
    import {objLookup, getExceptionErrorMessage, arrayRemove} from '../../util/common'
    import _ from 'underscore'

    export default {
        created() {
            let ystrday = moment().subtract(1, 'd');
            let today = moment();
            let tmrw = moment().add(1, 'd');
            let day2 = moment().add(2, 'd');
            let day3 = moment().add(3, 'd');
            this.dates = [
                {label: ystrday.format('[Yesterday] (ddd)'), value: ystrday.format('YYYY/MM/DD')},
                {label: today.format('[Today] (ddd)'), value: today.format('YYYY/MM/DD')},
                {label: tmrw.format('[Tomorrow] (ddd)'), value: tmrw.format('YYYY/MM/DD')},
                {label: day2.format('do MMM (ddd)'), value: day2.format('YYYY/MM/DD')},
                {label: day3.format('do MMM (ddd)'), value: day3.format('YYYY/MM/DD')},
            ];
            this.auctionDate = this.dates[1].value;
            this.getFavList();
        },
        data() {
            return {
                userSearchCancelToken: null,
                selectedRow: null,
                selectedRowIndex: null,
                fields: [
                    {label: 'List Name', key: 'name',},
                    {label: 'Last Sent', key: 'last_sent',},
                ],
                user_fields: [
                    {label: 'Members', key: 'name',},
                    // {label: 'Send Email', key: 'sendEmail'}, //hide for now
                    {label: 'Recommend', key: 'recommend'},
                    {label: 'Notify', key: 'notify'},
                ],
                dates: [],
                notify: [],
                sendMail: [],
                recommend: [],
                sendMailAll: false,
                notifyAll: false,
                recommendAll: false,
                addUser: false,
                addUserButton: true,
                userListActive: false,
                currentUsers: [],
                userName: '',
                getUserList: [],
                tagId: '',
                createList: true,
                listBox: false,
                listName: '',
                userId: '',
                confirmRemoveUser: false,
                confirmDeleteList: false,
                dismiss: 5,
                dismissCountDown: 0,
                showSuccess: false,
                messages: [],
                auctionDate: 0,
                activeTag: '',
                salesRep: false,
            }
        },
        computed: {
            ...mapState({
                favourites_state: state => state.favourites.all,
                all_favourites_count: state => state.favourites.all_favourites_count,
                all_favourites_users: state => state.favourites.all_favourites_users,
                per_page: state => state.favourites.per_page,
                from: state => state.favourites.from,
                to: state => state.favourites.to,
                last_page: state => state.favourites.last_page,
                total: state => state.favourites.total,
                auction_date: state => state.favourites.auction_date,
            }),
            favourites(){
                const favs = JSON.parse(JSON.stringify(this.favourites_state))
                favs.unshift({
                    created_at:null,
                    id:0, //we will use id 0 to show it's all favourites
                    name:"All favourites",
                    recommends: [],
                    updated_at:"2019-12-23 10:38:51",
                    user_id:this.loggedInUser.id,
                    users: this.all_favourites_users,
                    vehicles: [],
                })
                return favs
            },
            sendListButton(){
                if (this.selectedRow && this.selectedRow.id === 0) {
                    return this.currentUsers.length && this.auctionDate && this.all_favourites_count
                } else {
                    return this.selectedRow && this.currentUsers.length && this.selectedRow.vehicles_count && this.auctionDate;
                }
            }
        },
        methods: {
            setDefaultTagList() {
                const tagId = this.$route.query.tag_id;
                const data = this.favourites.filter((favourite, index) => {
                    if (favourite.id == tagId) {
                        this.$refs.favouritesTable.selectRow(index)
                        return true
                    }
                    return false
                })
                this.showUsers(data[0]);
            },
            onSendMailAll(){
                this.toggleAllUsersInList('sendMail', this.sendMailAll);
            },
            onNotifyAll(){
                this.toggleAllUsersInList('notify', this.notifyAll);
            },
            onRecommendAll(){
                this.toggleAllUsersInList('recommend', this.recommendAll);
            },
            toggleAllUsersInList(list_name, add){
                if (add) {
                    this.currentUsers.forEach(user => {
                        if (this[list_name].indexOf(user.id) === -1) {
                            this[list_name].push(user.id);
                        }
                    });
                } else {
                    this[list_name] = [];
                }
            },
            objLookup(obj, key) {
                return objLookup(obj, key);
            },
            onRowSelected (data) {
                if (data.length) {
                    this.showUsers(data[0]);
                } else {
                    this.resetData();
                }
            },
            onRowClicked (data, index) {
                this.selectedRowIndex = index;
            },
            changeUserList(){
                this.userListActive = false;
            },
            resetData(){
                this.tagId = null;
                this.userListActive = false;
                this.currentUsers = [];
                this.sendMail = [];
                this.recommend = [];
                this.excludeMail = [];
                this.notify = [];
                this.messages = [];
                this.selectedRow = null;
                this.confirmDeleteList = false;
                this.confirmRemoveUser = false;
            },
            showUsers(rowData) {
                this.resetData();
                this.userListActive = true;
                this.selectedRow = rowData;
                this.currentUsers = rowData.users || [];
                if (this.currentUsers.length) {
                    this.currentUsers.forEach(user => {
                        if ((user.pivot && user.pivot.send_email) || (user.in_favourites_list_all && user.in_favourites_list_all.send_email)) {
                            this.sendMail.push(user.id);
                        }
                        if ((user.pivot && user.pivot.recommend) || (user.in_favourites_list_all && user.in_favourites_list_all.recommend)) {
                            this.recommend.push(user.id);
                        }
                        if ((user.pivot && user.pivot.notify) || (user.in_favourites_list_all && user.in_favourites_list_all.notify)) {
                            this.notify.push(user.id);
                        }
                    })
                }
                this.tagId = rowData.id;
            },
            addMember() {
                this.addUser = true;
                this.addUserButton = false;
                this.$nextTick(() => {
                    if (this.$refs.user_search_input) {
                        this.$refs.user_search_input.focus();
                    }
                });
            },
            getUsers(){
                if (this.userName) {

                    if (this.userSearchCancelToken) {
                        this.userSearchCancelToken.cancel('Request cancelled for new request')
                    }
                    this.userSearchCancelToken = this.axios.CancelToken.source();
                    this.$store.dispatch('users/getUsers', {
                        args: {
                            searchUser: this.userName,
                            filter_by_statuses: [1,2,3],
                            filter_by_sales_rep: this.salesRep,
                            sort_asc: 1
                        },
                        cancelToken: this.userSearchCancelToken
                    }).then(response => {
                        this.getUserList = response.data;
                    }).catch(e => console.warn('FavouritesListPage/getUsers catch', e));
                } else {
                    this.getUserList = [];
                }
            },
            saveToList(userId) {
                this.$store.dispatch('favourites/storeFavouriteList', {
                    user_id: userId,
                    favourite_tag_id: this.tagId,
                }).then(data => {
                    let user = data.favourite.users[0];
                    this.currentUsers.filter(u => u.id !== user.id);
                    this.currentUsers.push(user);
                    this.$store.commit('favourites/updateUser', {
                        list_id: this.tagId,
                        user: user
                    });

                    if (user.pivot && user.pivot.send_email) {
                        this.sendMail.push(user.id);
                    }
                    if (user.pivot && user.pivot.recommend) {
                        this.recommend.push(user.id);
                    }
                    if (user.pivot && user.pivot.notify) {
                        this.notify.push(user.id);
                    }
                    this.memberActions();
                    this.$nextTick(() => {
                        this.$refs.favouritesTable.selectRow(this.selectedRowIndex)
                    })
                });
            },
            addOnce(id, name, company) {
                let user = [];
                user = {id, name, company, add_once: true}
                this.currentUsers.push(user);
                this.memberActions();
            },
            memberActions() {
                this.getUserList = [];
                this.userName = '';
                this.addUserButton = true;
                this.addUser = false;
            },
            toolTipAction(userId) {
                this.userId = userId;
            },
            removeMember(user_id) {
                if (this.$refs[`removeuser-${user_id}`]) {
                    this.$refs[`removeuser-${user_id}`].$emit('close');
                }
                this.$store.dispatch('favourites/deleteFavouriteUser', {
                    user_id: user_id,
                    favourite_tag_id: this.tagId,
                }).then(data => {
                    this.$store.commit('favourites/removeUser', {
                        list_id: this.tagId,
                        user_id
                    });
                    arrayRemove(this.notify, user_id);
                    arrayRemove(this.recommend, user_id);
                    arrayRemove(this.sendMail, user_id);
                    if (this.$refs[`removeuser-${user_id}`]) {
                        this.$refs[`removeuser-${user_id}`] = false;
                    }

                    this.$nextTick(() => {
                        this.$refs.favouritesTable.selectRow(this.selectedRowIndex)
                    })
                })
            },
            addToList() {
                this.createList = false;
                this.listBox = true;
            },
            storeList(e) {
                if (e.keyCode == '13' && e.key == 'Enter') {
                    if (this.listName) {
                        this.$store.dispatch('favouriteTags/storeFavoriteTag', {
                            name: this.listName,
                        }).then(() => {
                            this.$store.dispatch('favourites/getFavouriteList')
                        });
                    }
                    this.listName = '';
                    this.createList = true;
                    this.listBox = false;
                }
            },
            updateCurrentUsers() {
                this.$store.dispatch('favourites/getFavouriteList').then(users => {
                    let userData = users.favourites.data;
                    for (var i in userData) {
                        if (userData[i]['id'] == this.tagId) {
                            this.currentUsers = userData[i]['users']
                        }
                    }
                });
            },
            closeToolTip(ref) {
                if (this.$refs[ref]) {
                    this.$refs[ref].$emit('close');
                }
            },
            deleteList() {
                this.$store.dispatch('favourites/removeList', {
                    list_id: this.tagId
                }).then(() => {
                    this.resetData();
                });
            },
            async sendList() {
                if (this.sendMail) {
                    this.messages = [];
                    this.dismissCountDown = this.dismiss;
                    try {
                        let data = await this.$store.dispatch('favourites/sendFavouriteList', {
                            recommend: this.recommend,
                            send_email: [],
                            notify: this.notify,
                            tag_id: this.tagId,
                            date: this.auctionDate,
                        });
                        let message = data.message;
                        if (!data.message) {
                            message = 'There was a problem sending the email.';
                        }
                        this.messages = [{message, type: 'success'}];
                    } catch (e) {
                        console.warn(e);
                        this.messages = [{message: getExceptionErrorMessage(e), type: 'danger'}];
                    }

                }
            },
            formatAuctionDate(auction) {
                return window.moment(auction).format(this.defaultMomentDateFormat())
            },
            getFavList() {
                this.$store.dispatch('favourites/getFavouriteList', {
                    auction_date: this.auctionDate,
                }).then(() => {
                    if (this.$route.query.tag_id !== undefined) {
                        this.setDefaultTagList()
                    }
                });
            },
        }
    }

</script>



// WEBPACK FOOTER //
// resources/js/components/Favourites/FavouritesListPage.vue